/* Prakash 10/31/2022 3225736869 added Table Pagination.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
*/
import {React} from 'react';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {tableIcons} from '../../../../../components/TableIcons';
import {useSelector} from 'react-redux';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import PageLoader from '../../../../../components/PageLoader';
import GuiTable from '../../../../../components/FormComponents/GuiTable';

export default function JobExecutionTable({setOpen}) {
  const moment = require('moment-timezone');
  const useStyles = makeStyles({
    letterTable: {
      '& .MuiTableRow-root': {
        color: 'inherit',
        display: 'inherit',
        outline: 0,
        verticalAlign: 'middle',
      },
      '& .MuiTableBody-root': {
        display: 'inherit',
        textAlign: 'center',
      },
      '& .MuiTableSortLabel-root > div': {
        fontSize: '0.75rem !important',
        fontWeight: 'bold !important',
      },
    },
  });
  const {isLoading, taskExecutionData} = useSelector(
    ({addNightJob}) => addNightJob,
  );
  const columns = [

    {
      title: 'Execution Id',
      field: 'taskExecutionId',
      cellStyle: {textAlign: 'center'},
      minWidth: '120px',
    },
    {
      title: 'Sequence No.',
      field: 'seqNum',
      cellStyle: {textAlign: 'center'},
      minWidth: '120px',
    },
    {
      title: 'Task Code',
      field: 'taskCode',
      cellStyle: {textAlign: 'center'},
      minWidth: '130px',
    },

    {
      title: 'Start Time',
      field: 'startTime',
      cellStyle: {textAlign: 'right'},
      minWidth: '150px',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.startTime && moment(rowData.startTime).format('MM/DD/YYYY')}
        </>
      ),
    },
    {
      title: 'End Time',
      field: 'endTime',
      cellStyle: {textAlign: 'right'},
      minWidth: '150px',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.endTime && moment(rowData.endTime).format('MM/DD/YYYY')}
        </>
      ),
    },
    {
      title: 'Execution Status',
      field: 'execStatus',
      cellStyle: {textAlign: 'center'},
      minWidth: '160px',
    },
    {
      title: 'Error Details',
      field: 'errorDetails',
      cellStyle: {textAlign: 'center'},
      minWidth: '150px',
    },
  ];

  const classes = useStyles();

  const taskExecutionArray = (taskExecutionData || []).map((item) => ({
    ...item,
  }));


  return (
    <>
      <Grid item xs={12}>
        <div className={`custom-table global-field-table custom-actions-icon ${classes.letterTable} drag-and-drop-table custom-map-sec global-field-table`}>
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={taskExecutionArray}
            textAlign="left"
            options={{
              search: false,
              pageSize: defaultRows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{

              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                  }}
                />

              ),
            }}
            actions={[

            ]}
          />
        </div>
      </Grid>
      {isLoading && <PageLoader />}
    </>
  );
}
